import {
  fetchReadingsFromAPI,
} from '../../services/readingsService';

const getReadings = async (filters: {
  granularity?: string;
  farmId: string;
  startDate: string;
  endDate: string;
  sensorType?: string;
  wiseconnZoneId?: string;
  sectorId?: string;
  hourInterval?: number;
  name?: string;
  telemetryType?: string;
  sn?: string;
  chart?: string;
  isWeatherStation?: boolean;
}) => {
  // Fetch readings from API
  const readings = await fetchReadingsFromAPI({
    granularity: filters.granularity,
    farmId: filters.farmId,
    startDate: filters.startDate,
    endDate: filters.endDate,
    wiseconnZoneId: filters.wiseconnZoneId,
    sensorType: filters.sensorType,
    sectorId: filters.sectorId,
    hourInterval: filters.hourInterval,
    name: filters.name,
    telemetryType: filters.telemetryType,
    sn: filters.sn,
    chart: filters.chart,
    isWeatherStation: filters.isWeatherStation,
  });

  return readings;
};

export default getReadings;
